export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};

export const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === "true";

export const getAuth0MissingFields = (): string[] => {
  const missing: string[] = [];
  if (!auth0Config.domain) missing.push("REACT_APP_AUTH0_DOMAIN");
  if (!auth0Config.clientId) missing.push("REACT_APP_AUTH0_CLIENT_ID");
  return missing;
};
